export default __webpack_public_path__ + "static/media/purchase-price-range.6590ef90.svg";